import React from 'react'
import DashboardLayout from '../../admin-component/layout/dashboardLayout';
import HotelsList from './list';

const BookingHistoryList = () => {
    return (
        <DashboardLayout>
            <HotelsList />
        </DashboardLayout>
    );
};
export default BookingHistoryList;